import React, { useState, useEffect } from "react";
import Navbaradmin from "../navbar";
import Sidebaradmin from "../Sidebar";
import QuestionTable from "./QuestionTable";
import SearchBar from "./SearchBar";
import EditQuestionForm from "./AdminEditQuestionForm";
import AddQuestionForm from "./AddQuestionForm";
import DeletedList from "./DeletedList"; // Import the DeletedList component

export default function Adminpractice() {
  const [searchQuery, setSearchQuery] = useState("");
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [addQuestionData, setAddQuestionData] = useState({});
  const [editFormData, setEditFormData] = useState({});
  const [showAddQuestion, setShowAddQuestion] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [deletedQuestions, setDeletedQuestions] = useState([]); // State for deleted questions
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedModel, setSelectedModel] = useState("");
  const [limit, setLimit] = useState(10);
  const [searchType, setSearchType] = useState("name");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("questions");

  const fetchQuestions = async () => {
    setLoading(true);
    setError(null);
    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        model: selectedModel,
        searchType,
        search: searchQuery,
      });
      console.log("Query Params:", queryParams.toString());

      const response = await fetch(
        `/api/admin/search?${queryParams.toString()}`
      );
      const data = await response.json();

      if (response.ok) {
        setQuestions(data.data);
        setTotalPages(data.totalPages);
      } else {
        throw new Error(data.error || "Failed to fetch questions");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
  };

  const handleSearchClick = () => {
    fetchQuestions();
  };

  const handleEditClick = (question) => {
    console.log("Editing Question:", question); // Log the entire question object
    if (question) {
      setEditingQuestion(question); // Ensure the question has _id
      setEditFormData(question);
      setActiveTab("edit");
      console.log("Active Tab Set To:", "edit"); // Log state change
    } else {
      console.error("Question has no _id:", question); // Log for debugging
    }
  };

  const handleDeleteClick = (id) => {
    setQuestions((prevQuestions) => prevQuestions.filter((q) => q.id !== id));
    // Move deleted question to deletedQuestions state
    const deletedQuestion = questions.find((q) => q.id === id);
    if (deletedQuestion) {
      setDeletedQuestions((prevDeleted) => [
        ...prevDeleted,
        { ...deletedQuestion, deletedAt: Date.now() },
      ]);
    }
  };

  const handleRestoreQuestion = (id) => {
    setDeletedQuestions((prevDeleted) =>
      prevDeleted.filter((q) => q.id !== id)
    );
    // Optionally, restore the question back to the main questions list if needed
    const restoredQuestion = deletedQuestions.find((q) => q.id === id);
    if (restoredQuestion) {
      setQuestions((prevQuestions) => [...prevQuestions, restoredQuestion]);
    }
  };

  const handleSaveChanges = () => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((q) =>
        q.id === editingQuestion.id ? { ...q, ...editFormData } : q
      )
    );
    setEditingQuestion(null);
    setActiveTab("questions");
  };

  const handleAddNewQuestion = () => {
    const newQuestion = { id: Date.now(), ...addQuestionData };
    setQuestions((prevQuestions) => [...prevQuestions, newQuestion]);
    setShowAddQuestion(false);
    setAddQuestionData({});
    setActiveTab("questions");
  };

  useEffect(() => {
    fetchQuestions();
  }, [page, limit, searchQuery, selectedModel, searchType]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbaradmin />
      <div className="flex flex-1">
        <Sidebaradmin />
        <div className="flex-1 p-8 space-y-8 max-w-6xl mx-auto">
          {error && <div className="text-red-500">{error}</div>}
          <>
            <SearchBar
              searchQuery={searchQuery}
              handleSearch={handleSearch}
              handleSearchClick={handleSearchClick}
              selectedModel={selectedModel}
              handleModelChange={handleModelChange}
              currentPage={page}
              totalPages={totalPages}
              handlePageChange={setPage}
              setLimit={setLimit}
              searchType={searchType}
              setSearchType={setSearchType}
              setSearchQuery={setSearchQuery}
            />
            {/* Tab Navigation */}
            <div className="mt-4 border-b border-gray-200">
              <nav className="flex space-x-4">
                <button
                  className={`px-4 py-2 font-semibold ${
                    activeTab === "questions"
                      ? "border-b-2 border-blue-500 text-blue-600"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                  onClick={() => setActiveTab("questions")}
                >
                  Question Table
                </button>
                <button
                  className={`px-4 py-2 font-semibold ${
                    activeTab === "add"
                      ? "border-b-2 border-blue-500 text-blue-600"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                  onClick={() => {
                    setActiveTab("add");
                    setShowAddQuestion(true);
                  }}
                >
                  Add Question
                </button>
                <button
                  className={`px-4 py-2 font-semibold ${
                    activeTab === "deleted"
                      ? "border-b-2 border-blue-500 text-blue-600"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                  onClick={() => setActiveTab("deleted")}
                >
                  Deleted Questions
                </button>
              </nav>
            </div>

            {activeTab === "questions" && (
              <QuestionTable
                questions={questions}
                currentPage={page}
                limit={limit}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                searchQuery={searchQuery}
              />
            )}
            {activeTab === "add" && (
              <AddQuestionForm
                formData={addQuestionData}
                handleInputChange={(e) =>
                  setAddQuestionData({
                    ...addQuestionData,
                    [e.target.name]: e.target.value,
                  })
                }
                handleAddNewQuestion={handleAddNewQuestion}
                setShowAddQuestion={setShowAddQuestion}
              />
            )}
            {activeTab === "edit" && editingQuestion && (
              <EditQuestionForm
                questionId={editingQuestion} // Ensure the question's _id is passed here
                formData={editFormData}
                handleInputChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    [e.target.name]: e.target.value,
                  })
                }
                saveChanges={handleSaveChanges}
                setEditingQuestion={setEditingQuestion}
              />
            )}
            {activeTab === "deleted" && (
              <DeletedList
                deletedQuestions={deletedQuestions}
                restoreQuestion={handleRestoreQuestion}
              />
            )}
            <div className="flex justify-between items-center mt-4">
              <div className="flex items-center">
                <span className="text-sm mr-2">Items per page:</span>
                <select
                  value={limit}
                  onChange={(e) => setLimit(Number(e.target.value))}
                  className="border border-gray-300 rounded-md p-1"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>
              <div className="flex items-center">
                {page > 1 && (
                  <button
                    onClick={() => setPage(page - 1)}
                    className="bg-blue-600 text-white rounded-md p-1 mx-1"
                  >
                    Previous
                  </button>
                )}
                <span>
                  Page {page} of {totalPages}
                </span>
                {page < totalPages && (
                  <button
                    onClick={() => setPage(page + 1)}
                    className="bg-blue-600 text-white rounded-md p-1 mx-1"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
}
